import styled from 'styled-components';

export const ResetPasswordCodeSC = styled.div`
  .insert-code-text {
    color: #333d6c;
    margin-bottom: 30px;
  }

  .insert-code-email {
    font-weight: bold;
  }

  .verification-code-input {
    position: relative;
    width: 100% !important;
    display: flex;
    justify-content: center;
    margin-bottom: 3px;

    div:first-child {
      display: grid;
      grid-template-rows: 50px;
      grid-auto-flow: column;
      grid-auto-columns: minmax(30px, 50px);
      grid-column-gap: 8px;
    }

    input {
      width: auto !important;
      height: auto !important;
      border-radius: 10px;
      border: none;
      background: #caccd8;
      opacity: 0.3;
      font-family: 'Mulish', sans-serif;
    }
  }

  .resend-email {
    text-align: center;
    margin-top: 30px;
  }

  .resend-email_txt {
    display: block;
    margin-bottom: 5px;
  }

  .resend-email_btn {
    font-weight: 700;
    color: #6ad5e5;
    cursor: pointer;
  }

  .resend-email-error {
    margin-top: 5px;
  }
`;
